class ContactDrawer extends HTMLElement {
  constructor() {
    super();

    this.summaryElement = document.querySelector('header-drawer')?.mainDetailsToggle?.querySelector('summary');
    this.header = document.querySelector('sticky-header');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#ContactDrawer-Overlay').addEventListener('click', this.close.bind(this));

    document.addEventListener('click', (event) => {
      if(event.target && event.target.matches('[data-product-contact-trigger]')) {
        event.preventDefault();
        if(this.header) this.header.preventHide = true;
        this.open(event.target);
      }
    });

    this.summaryElement.addEventListener('click', (event) => {
      if(this.summaryElement.getAttribute('aria-controls') === 'contact-drawer') {
        event.preventDefault();
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if(this.summaryElement) {
      this.summaryElement.setAttribute('aria-expanded', 'true');
      this.summaryElement.setAttribute('aria-controls', 'contact-drawer');
    }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    window.setHeaderHeightVar();

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('ContactDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      const hiddenStickyHeader = document.querySelector('.shopify-section-header-hidden sticky-header');
      if(hiddenStickyHeader) hiddenStickyHeader.reveal();
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    if(this.summaryElement) {
      this.summaryElement.setAttribute('aria-expanded', 'false');
      this.summaryElement.setAttribute('aria-controls', 'menu-drawer');
    }
    if(this.header) this.header.preventHide = false;
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('contact-drawer', ContactDrawer);


